import { lazy, Suspense } from "react";

import { useRoutes } from "react-router-dom";
import AboutUs from "../pages/AboutUs.js";
import ContactUs from "../pages/ContactUs.js";
const Home = lazy(() => import("../pages/Home.js"));
const Navbar = lazy(() => import("../components/layout/navbar.js"));
const Footer = lazy(() => import("../components/layout/Footer.js"));

const ResearchPage = lazy(() => import("../pages/ResearchPage.js"));

const router_path = [
  {
    path: "/",
    element: <Home />,
    isNavbarFooter: true,
  },
  {
    path: "/about-us",
    element: <AboutUs />,
    isNavbarFooter: true,
  },
  {
    path: "/research",
    element: <ResearchPage />,
    isNavbarFooter: true,
  },
  {
    path: "/contact-us",
    element: <ContactUs />,
    isNavbarFooter: true,
  },
];

const RouteController = () => {
  console.log("this is routing");
  // const User = false;
  const routing = useRoutes(
    router_path.map((route) => {
      return {
        ...route,
        element: (
          <>
            {route.isNavbarFooter && <Navbar />}
            {route.element}
            {<Footer />}
          </>
        ),
      };
    })
  );

  return (
    <>
      <Suspense>
        {/* <Navbar /> */}
        {routing}
        {/* <PrimaryFooter /> */}
      </Suspense>
    </>
  );
};

export default RouteController;
